import { createPlugin } from "./plugin.mjs";
import { createUnheadRecaptcha } from "./script-manager/unhead.mjs";
export * from "./api.mjs";
const plugin = createPlugin(createUnheadRecaptcha);
export { plugin as default, plugin as VueRecaptchaPlugin };
